/*
 * Copyright (c) 2019 brightlamp
 */

import { axiosInit } from './axiosSetup'

export default
{
    namespaced: true,
    state:
    {
    },
    mutations:
    {
    },
    actions:
    {
        SEND_MESSAGE: async (context, payload) =>
        {
            const axios = await axiosInit();
            await axios.post('/send-message', payload)
        }
    }
}